"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
const i0 = require("@angular/core");
const i1 = require("../../../projects/angular-sdk/src/4d-mapper.service");
const i2 = require("@angular/material/dialog");
DEBUG_1.DEBUG.open('/service/epsg-helper.ts');
const rxjs_1 = require("rxjs");
const _4d_mapper_1 = require("4d-mapper");
const Constants_1 = require("../commons/Constants");
const proj4_1 = require("proj4");
const material_1 = require("@angular/material");
const epsgcode_dialog_component_1 = require("../commons/dialogs/epsgcode/epsgcode-dialog.component");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
class EpsgHelperService {
    constructor(fourD, dialog) {
        this.fourD = fourD;
        this.dialog = dialog;
        this.__ID = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugPrimary = Constants_1.Constants._gray;
        this.debugSecondary = Constants_1.Constants._black;
        this.cacheDescriptions = new Map();
        this.cacheObjects = new Map();
        // defaults
        this.convertTo = 'EPSG:4326';
        this.convertFrom = 'PROJCS["GDA_1994_MGA_Zone_56",GEOGCS["GCS_GDA_1994",DATUM["D_GDA_1994",SPHEROID["GRS_1980",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Transverse_Mercator"],PARAMETER["False_Easting",500000.0],PARAMETER["False_Northing",10000000.0],PARAMETER["Central_Meridian",153.0],PARAMETER["Scale_Factor",0.9996],PARAMETER["Latitude_Of_Origin",0.0],UNIT["Meter",1.0]]';
        this.latestConvertedTo = null;
        this.latestConvertedFrom = null;
        DEBUG_1.DEBUG.log('/service/epsg-helper.service.ts');
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
    }
    openEPSGDialogWith(title, incoming, desc, posBtn, negBtn) {
        let dialogRef = this.dialog.open(epsgcode_dialog_component_1.EpsgcodeDialog, {
            width: '65%',
            height: '86%',
            data: { title: title, incoming: incoming, text: desc, posBtn: posBtn, negBtn: negBtn }
        });
        return dialogRef.afterClosed();
    }
    selectCodeObservable(incoming = null) {
        const tmp = new rxjs_1.Observable(subscriber => {
            this.openEPSGDialogWith('MAP.PHOTOGRAM.SELECT_EPSG_CODE_IMPORTED_FILE', incoming).subscribe(code => {
                if (this.debug) {
                    console.log('%c epsg-helper %c selectEPSGCode(' + incoming + ')', this.debugPrimary, this.debugSecondary, code);
                }
                if (code) {
                    // assumes 'value' is always the actual EPSG code
                    let q = this.getCodeObjectObservable(code.uid).subscribe(res => {
                        // make a unified return object
                        /*
                        let ret = {
                          uid: res.uid ? res.uid : res.id,
                          name: res.uid ? res.name : res.desc.match(/"([^']+)"/)[1],
                          desc: res.desc
                        };*/
                        if (this.debug) {
                            console.log('%c epsg-helper %c selectEPSGCode() returned', this.debugPrimary, this.debugSecondary, code, res);
                        }
                        subscriber.next(res);
                        subscriber.complete();
                    });
                }
            });
        });
        return tmp;
    }
    isProjected(value) {
        // if ( this.debug ) { console.log ( 'epsg-helper :: isProjected('+value+')'); }
        if (value.toLowerCase().indexOf("projcs[") !== -1)
            return true;
        return false;
    }
    getCodeName(value) {
        let parts = (' ' + value).trim().split('"');
        let me = parts[1];
        return me;
    }
    // wrapper for Vasat observers
    getCodeObjectObservable(value = 4326, source = 'unknown') {
        if (!value) {
            value = 4326;
        }
        let isCached = this.cacheObjects.get(value);
        if (isCached) {
            if (this.debug) {
                console.log('%c epsg-helper %c getCodeObject(' + value + ') CACHED', this.debugPrimary, this.debugSecondary, isCached, source);
            }
            return rxjs_1.of(isCached);
        }
        let sub = null;
        const me = new rxjs_1.Observable(subscriber => {
            if (this.debug) {
                console.log('%c epsg-helper %c getCodeObject(' + value + ') Observable', this.debugPrimary, this.debugSecondary, source, subscriber);
            }
            let q = this.fourD.V.api('/epsg/' + value + '?full=true').subscribe(res => {
                if (res['OGC']) {
                    sub = res.OGC;
                }
                else if (res['ogc']) {
                    sub = res.ogc;
                }
                else if (res['default']) {
                    sub = res.default;
                }
                if (sub) {
                    // make a unified return object
                    let ret = {
                        uid: value,
                        name: sub.match(/"((?:\\.|[^"\\])*)"/)[1],
                        desc: sub,
                        isProjected: this.isProjected(sub),
                        source: '/epsg?' + value
                    };
                    if (this.debug) {
                        console.log('%c epsg-helper %c getCodeObject(' + value + ') sub return', this.debugPrimary, this.debugSecondary, source, ret);
                    }
                    subscriber.next(ret);
                    subscriber.complete();
                }
                else {
                    this.fourD.V.searchByObject(_4d_mapper_1.EPSGCodes).equals('uid', value).limit(201).queryObservable().subscribe(items => {
                        let obj = items.items[0];
                        obj.desc = sub;
                        obj['isProjected'] = this.isProjected(obj['desc']);
                        obj['source'] = 'EPSGCodes.equals(' + value + ')';
                        this.cacheObjects.set(value, obj);
                        if (this.debug) {
                            console.log('%c epsg-helper %c getCodeObject(' + value + ') sub sub return', this.debugPrimary, this.debugSecondary, source, obj);
                        }
                        subscriber.next(obj);
                        subscriber.complete();
                    });
                }
            });
        });
        return me;
    }
    convert(in_from = null, in_to = null, in_coord) {
        this.latestConvertedFrom = this.dup(in_from ? in_from : this.convertFrom);
        this.latestConvertedTo = this.dup(in_to ? in_to : this.convertTo);
        const coord = this.dup(in_coord);
        // if ( this.debug ) { console.log ( '%c epsg-helper :: convert()', Constants._pink, in_from, in_to, this.latestConvertedFrom, this.latestConvertedTo, coord ); }
        return proj4_1.default(this.latestConvertedFrom, this.latestConvertedTo).forward(coord);
    }
    // helpers
    // duplicate simple objects and arrays
    dup(n) {
        return JSON.parse(JSON.stringify(n));
    }
    clean(n) {
        return n.trim();
    }
}
EpsgHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EpsgHelperService_Factory() { return new EpsgHelperService(i0.ɵɵinject(i1.FourDService), i0.ɵɵinject(i2.MatDialog)); }, token: EpsgHelperService, providedIn: "root" });
exports.EpsgHelperService = EpsgHelperService;
